module.exports = __webpack_public_path__ + "static/cookies-a26b7b9fff17f1e2cdb4f0f97d43eddf.png";